import { KW_DECIMAL_PLACES, KW_TO_MW_THRESHOLD, MW_DECIMAL_PLACES } from "@/appConfig";

export function kilowattToMegawattAsNumber(kw: number, maxKw: number) {
  if (maxKw > KW_TO_MW_THRESHOLD) return parseFloat((kw / 1000).toFixed(MW_DECIMAL_PLACES));
  return parseFloat(kw.toFixed(KW_DECIMAL_PLACES));
}

export default function kilowattToMegawattDisplay(kw: number, maxKw: number = kw) {
  const kwValue = kilowattToMegawattAsNumber(kw, maxKw);
  if (maxKw > KW_TO_MW_THRESHOLD) {
    return `${kwValue} MW`;
  }
  return `${kwValue} kW`;
}

export function kilowattToMegawattAsObject(kw: number, maxKw: number = kw) {
  const units = maxKw > KW_TO_MW_THRESHOLD ? "MW" : "kW";
  return {
    units,
    display: kilowattToMegawattDisplay(kw, maxKw),
    displayPerHour: `${kilowattToMegawattAsNumber(kw, maxKw)} ${units === "MW" ? "MWh" : "kWh"}`,
    displayWithoutMax: kilowattToMegawattDisplay(kw),
    kwDisplay: `${kw} kW`,
    mwDisplay: `${kw / 1000} mW`,
    numberValue: kilowattToMegawattAsNumber(kw, maxKw)
  };
}
